<template>
    <div class="bg-[#0E1420] rounded-[9px]">
        <div class="flex justify-center mt-[13px]">
            <img src="@/assets/logo.svg" class="w-[76px]">
        </div>
        <div class="text-center px-[33px] mt-[20px] text-[15px] text-white font-semibold">
            {{ alertText }}
        </div>
        <div class="text-center mt-[11px] px-[33px] block text-[13px] text-white font-normal">
            Ваші зміни будуть втрачені якщо ви не збережете їх.
        </div>
        <div class="flex flex-col justify-center items-center mt-[17px]">
            <button @click="$emit('doSave')" class="bg-[#21A179] text-[#0E1420] hover:bg-opacity-90 font-semibold rounded-[5px] text-center w-[228px] py-[4px] mb-[6px]">Зберегти</button>
            <button @click="$emit('dontSave')" class="bg-[#C6F100] text-[#0E1420] hover:bg-opacity-90 font-semibold rounded-[5px] text-center w-[228px] py-[4px]">Не зберігати</button>
        </div>
        <div class="flex flex-col justify-center items-center mt-[16px] mb-[16px]">
            <button @click="$emit('returnToCurrent')" class="bg-[#C6F100] text-[#0E1420] hover:bg-opacity-90 font-semibold rounded-[5px] text-center w-[228px] py-[4px]">Відмінити</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'exit-confirm-form',

        props: {
            alertText: {
                type: String,
                default: 'test'
            }
        }
    }
</script>
